import { Row, Col, Typography, Image, Layout } from 'antd'
const { Text } = Typography
import { ArrowDownOutlined } from '@ant-design/icons'
import { useRef } from 'react'

const LinkWithPicture = ({
  text,
  img = 'images/common/whats_next.webp',
  content,
}) => {
  const contentRef = useRef(null)

  const scrollToRef = (ref) => {
    window.scrollTo(0, ref.current.offsetTop)
  }
  return (
    <>
      <Text
        className="link-with-picture"
        onClick={() => scrollToRef(contentRef)}
      >
        <Row className="whats-next" align="middle">
          <Col lg={{ span: 6, offset: 5 }} xs={{ span: 4 }}>
            <Image src={img} alt={text} preview={false} />
          </Col>
          <Col lg={{ span: 5 }} xs={{ span: 9 }}>
            <Text className="whats-next-text">
              {text}&nbsp;
              <ArrowDownOutlined />
            </Text>
          </Col>
        </Row>
      </Text>
      <Layout className="link-with-picture-content" ref={contentRef}>
        {content}
      </Layout>
    </>
  )
}
export default LinkWithPicture
